import ExceptionConfigSection from './ExceptionConfigSection';
import { paFieldCategories, paFieldLabels } from '../constants';

const PaExceptionsSection = (props: any) => (
  <ExceptionConfigSection title="PA Layout" categories={paFieldCategories} fieldLabels={paFieldLabels} {...props} />
);

export default PaExceptionsSection;
